import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  UrlTree,
} from "@angular/router";
import { AuthNewService } from "src/auth/services/auth-new.service";
import { canManageDataManagement } from "../app.constants";

@Injectable({
  providedIn: "root",
})
export class DataManagementGuardService {
  constructor(
    private auth: AuthNewService,
    private router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    return canManageDataManagement(this.auth.userValue?.payload)
      ? true
      : this.router.createUrlTree(["/app/expenses/expenses"]);
  }
}
